import styled from "styled-components"

export {
  TotalsComparison,
  TotalsHeader,
  TotalsRow,
  TotalsLabel,
  TotalsCell,
  OrderLinesTable as ShippingFeesTable,
  TableHeader
} from "./OrderLinesModificationAction.styled"

export const TableBody = styled.tbody`
  tr {
    border-bottom: 1px solid ${(p) => p.theme.colors.borderLight};

    &:last-child {
      border-bottom: none;
    }

    &:hover {
      background: ${(p) => p.theme.colors.backgroundHover};
    }
  }

  td {
    padding: 0.8rem 0.5rem;
    vertical-align: middle;

    &:not(:first-child) {
      text-align: right;
    }
  }
`
